module.exports = __webpack_public_path__ + "img/carAttr.jpg";